import React from 'react';

/**
 * Top blue bar with invoice title, supplier, date, and action buttons.
 */
const InvoiceHeader = ({
  invoice,
  id,
  navigate,
  canGeneratePZ,
  autoMappingLoading,
  onEdit,
  onCorrection,
  onAutoMap,
  onGeneratePZ,
  onBack
}) => {
  return (
    <div style={{
      backgroundColor: 'var(--primary)', color: '#fff', padding: '0.5rem 1rem',
      marginBottom: '0.75rem', borderRadius: '0.375rem',
      display: 'flex', justifyContent: 'space-between', alignItems: 'center',
      boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)'
    }}>
      <div>
        <h5 style={{ margin: 0, fontSize: '14px', fontWeight: '600' }}>
          Faktura {invoice?.numer_faktury || `FZ-${id}`}
        </h5>
        <div style={{ fontSize: '10px', opacity: 0.9 }}>
          {invoice?.dostawca_nazwa || 'Dostawca'} | {invoice?.data_faktury ? new Date(invoice.data_faktury).toLocaleDateString('pl-PL') : '-'}
        </div>
      </div>
      <div style={{ display: 'flex', gap: '6px' }}>
        <button onClick={onEdit} style={{
          padding: '4px 10px', fontSize: '11px', fontWeight: '500',
          border: '1px solid var(--warning)', color: 'var(--warning)'
        }}>Edytuj</button>
        <button onClick={onCorrection} style={{
          padding: '4px 10px', fontSize: '11px', fontWeight: '500',
          border: '1px solid var(--orange)', color: 'var(--orange)'
        }}>Korekta</button>
        <button onClick={onAutoMap} disabled={autoMappingLoading} style={{
          padding: '4px 10px', fontSize: '11px', fontWeight: '500',
          border: '1px solid var(--success)', color: 'var(--success)',
          cursor: autoMappingLoading ? 'not-allowed' : undefined,
          opacity: autoMappingLoading ? 0.7 : 1
        }}>{autoMappingLoading ? '...' : 'Auto-mapuj'}</button>
        {canGeneratePZ && (
          <button onClick={onGeneratePZ} disabled={autoMappingLoading} style={{
            padding: '4px 10px', fontSize: '11px', fontWeight: '500',
            border: '1px solid var(--info)', color: 'var(--info)',
            cursor: autoMappingLoading ? 'not-allowed' : undefined,
            opacity: autoMappingLoading ? 0.7 : 1
          }}>Generuj PZ</button>
        )}
        <button onClick={onBack} style={{
          padding: '4px 10px', fontSize: '11px', fontWeight: '500',
          border: '1px solid rgba(255,255,255,0.6)', color: '#fff'
        }}>Lista</button>
      </div>
    </div>
  );
};

export default InvoiceHeader;
